module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/gallery/gallery1-e2d4efd1fb2e82f185c9a3c9d668424e.jpg";